import UserModel, { RawUser } from "@/models/user";

export type User = RawUser;

export default class UserController {
  private phone: string;

  constructor(phone: string) {
    this.phone = phone;
  }

  public getUserProfile(): Promise<User> {
    return UserModel.getUserProfile(this.phone);
  }

  public changeAvatar(imageUrl: string) {
    return UserModel.changeAvatar(this.phone, imageUrl);
  }
}
